export class MediaScale {
    constructor () {
        this.contexts = [...document.querySelectorAll('.js-animation-media-scale')];

        this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.observer = null;

        this.previousAnimationElement = null;

        if (this.contexts.length) this.init();
    }

    init () {
        if (this.supportsWAAPI()) {
            this.observer = new IntersectionObserver(entries => {
                entries.forEach(entry => this.handleIntersection(entry));
            });

            this.contexts.forEach(context => {
                this.observer.observe(context);
            });
        } else {
            document.documentElement.classList.add('js-no-waapi');
        }
    }

    supportsWAAPI () {
        return typeof Element.prototype.animate === 'function' &&
               typeof Animation !== 'undefined';
    }

    async handleIntersection (entry) {
        if (!entry.isIntersecting) return;

        const delay = () => {
            let delay = 0;
            if (this.previousAnimationElement?.parentElement.getBoundingClientRect().top === entry.target.parentElement.getBoundingClientRect().top &&
                this.previousAnimationElement?.parentElement.getBoundingClientRect().left !== entry.target.parentElement.getBoundingClientRect().left) {
                delay = 200 + this.previousAnimationElement.getAnimations()[0]?.effect.getComputedTiming().delay;
            }

            return delay;
        }

        try {
            const scaleAnimation = entry.target.animate([
                { transform: 'scale(1.1)', opacity: 0 },
                { transform: 'scale(1)', opacity: 1 }
            ], {
                duration: 1000,
                delay: delay(),
                easing: 'ease-in-out',
                fill: 'forwards'
            });

            if (this.prefersReducedMotion) scaleAnimation.finish();

            this.previousAnimationElement = entry.target;

            await scaleAnimation.finished;

            this.previousAnimationElement = null;

            scaleAnimation.commitStyles();
            scaleAnimation.cancel();

            this.observer.unobserve(entry.target);
        } catch (error) {
            this.previousAnimationElement = null;
            document.documentElement.classList.add('js-no-waapi');
            this.observer.unobserve(entry.target);
            this.observer.disconnect();
        }
    }
}
